<ddc-rotating-border-card>
  <div class="info-card-container">
    <mat-horizontal-stepper #stepper class="responsive-stepper" labelPosition="bottom" [linear]="true">
      <ng-template matStepperIcon="edit">
        <mat-icon>lightbulb</mat-icon>
      </ng-template>

      <mat-step *ngFor="let step of data.stepData; let i = index" label="{{ step.title }}">
        <div class="step-content">
          <div class="content-layout">
            <div class="common-info-picture">
              <img class="responsive-image" alt="{{ step.title }}" src="{{ media_path }}{{ step.info_pic }}" />
            </div>
            <div class="common-info-text">
              <div class="description-text">
                {{ step.description }}
              </div>
            </div>
          </div>
          <div class="common-info-button-container">
            <button
              class="common-info-button"
              *ngIf="i !== 0 && i !== data.stepData.length - 1"
              extended
              mat-flat-button
              matStepperPrevious
            >
              Back
            </button>
            <button
              class="common-info-button"
              *ngIf="i !== data.stepData.length - 1"
              color="primary"
              mat-flat-button
              matStepperNext
            >
              Next
            </button>
            <button
              class="common-info-button"
              *ngIf="i === data.stepData.length - 1"
              extended
              mat-flat-button
              (click)="closeStepper()"
            >
              Done
            </button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</ddc-rotating-border-card>
